import { ApiError, NetworkError } from '../api/http'
import { t } from '../i18n'

export function errorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.status === 403) return t('lib.errorForbidden')
    if (e.status === 404) return t('lib.errorNotFound')
    // The ingress proxy answers an oversized body itself, with HTML rather than a problem document.
    if (e.status === 413) return t('lib.errorTooLarge')
    return e.problem.detail ?? e.problem.title ?? t('lib.errorRequestFailed', { status: e.status })
  }
  if (e instanceof NetworkError) return t('lib.errorNetwork')
  return e instanceof Error ? e.message : t('common.somethingWentWrong')
}

/** The API answers a correct password on an MFA-protected account with 401 `mfa_required`; the login page
 * reacts to that by asking for the code rather than showing an error. */
export function isMfaRequired(e: unknown): boolean {
  return e instanceof ApiError && e.status === 401 && e.problem.code === 'mfa_required'
}

export function loginErrorMessage(e: unknown): string {
  if (e instanceof ApiError && e.status === 401) {
    if (e.problem.code === 'mfa_required') return t('lib.loginMfaRequired')
    if (e.problem.code === 'invalid_mfa_code') return t('lib.loginInvalidMfa')
    return t('lib.loginIncorrect')
  }
  if (e instanceof ApiError && e.status === 429) return t('lib.loginTooMany')
  return errorMessage(e)
}

export function fieldErrors(e: unknown): Record<string, string> {
  if (!(e instanceof ApiError) || !e.problem.errors) return {}
  return Object.fromEntries(Object.entries(e.problem.errors).map(([k, v]) => [k.charAt(0).toLowerCase() + k.slice(1), v[0] ?? t('lib.fieldInvalid')]))
}
